<div class="text-center">
  <div class="spinner-border" [ngClass]="{ 'spinner-border-sm': size === 'small' }" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
